import catchWrapper from 'common/utils/catchWrapper'

const SESSION_TRACKING_KEY = 'artkive[tracking]'

const handleOncePerSession = (type, productId, cb) => {
  const dataObj =
    catchWrapper(() => {
      const data = sessionStorage.getItem(SESSION_TRACKING_KEY)
      return JSON.parse(data)
    }) || {}
  const key = `${type}#${productId || ''}`

  if (!dataObj[key]) {
    sessionStorage.setItem(SESSION_TRACKING_KEY, JSON.stringify({ ...dataObj, [key]: 1 }))
    cb()
  } else {
    console.log('session exists, not setting') // eslint-disable-line no-console
  }
}

export default handleOncePerSession
